import { Container } from 'react-bootstrap';
import Header from '../header/header';
import styles from './layout.module.css';

function Layout(props) {

    var year = new Date().getFullYear();
    return (
        <>
            <Header />
            <Container>
                {props.children}
            </Container>
            <div class={styles.footer}>Copyright {year}</div>
        </>
    );
};

export default Layout;